//componente per spostare su o giu nella toc ogni servizio
import React from 'react';
import { connect } from 'react-redux';
import {selectDataList} from '../../../../redux'
import MenuItem from '@material-ui/core/MenuItem';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

function UpDownService(props) {
    const { t } = useTranslation();
    
    const dataList = props.dataList.data
    
    const indexService = props.dataList.data.children.findIndex(element=>{return element.children.find(x=>{return x.id===props.nodes.id && x.name===props.nodes.name})})
    /* 
    console.log(x.name,"servicename") *//* .find(x=>{return x.id===props.nodes.id && x.name===props.nodes.name}) */
    
    
     function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, -1, arr.splice(old_index, 1)[0]);
        return arr; 
    }; 
    function array_move2(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, -1, arr.splice(old_index, 1)[-1]);
      return arr; 
  }; 


     const downService =() =>{
        
        if ( indexService < (props.dataList.data.children.length - 1) &&  props.dataList.data.children.length > 1 ){
          
            array_move(dataList.children,indexService,indexService+1)
            
            props.changeDataList(dataList)
            
        }
             
          }
    
          const upService = () =>{
              
              
                  if (indexService === -1  && props.dataList.data.children.length > 1  ){
                      
                      
                    array_move(dataList.children, indexService,indexService -1)
                    props.changeDataList(dataList)
      
          }
          
           
          }
 
    return  <div>
     <MenuItem  onClick={upService} >{t("Sposta su")}</MenuItem>  
    <MenuItem  onClick={downService} >{t("Sposta giu")}</MenuItem>
    
        </div>

}

const mapStateToProps = state => {
    return {
        dataList: state.dataList
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      changeDataList: (dataList) => dispatch(selectDataList(dataList))
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(UpDownService)